<div class="formulario">
    <mat-accordion class="example-headers-align">
        <mat-expansion-panel class="panel-filtros">
            <mat-expansion-panel-header class="panel-cabecera">
                <mat-panel-title>FILTROS</mat-panel-title>
                <mat-panel-description>
                    Despliegue para mostrar los filtros.
                    <mat-icon>filter_list</mat-icon>
                </mat-panel-description>
            </mat-expansion-panel-header>
            <form [formGroup]="group">
                <div class="a-w1-row">
                    <mat-form-field appearance="outline" class="a-w6">
                        <mat-label>Fecha desde</mat-label>
                        <input formControlName="desde" matInput [matDatepicker]="picker1" autocomplete="off"
                            readonly [disabled]="true" (dateChange)="onDateChange($event,'desde','group')">
                        <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker1 color="primary"></mat-datepicker>
                        <mat-error>Ingrese la fecha desde</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="a-w6">
                        <mat-label>Fecha hasta</mat-label>
                        <input formControlName="hasta" matInput [matDatepicker]="picker2" autocomplete="off"
                            readonly [disabled]="true" (dateChange)="onDateChange($event,'hasta','group')">
                        <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                        <mat-datepicker #picker2 color="primary"></mat-datepicker>
                        <mat-error>Ingrese la fecha hasta</mat-error>
                    </mat-form-field>
                    <mat-form-field class="a-w3" appearance="outline">
                        <mat-label>Ejecutivos</mat-label>
                        <mat-icon matSuffix (click)="limpiar('ejecutivos', 'group')">close</mat-icon>

                        <mat-select formControlName="ejecutivos" multiple
                            (selectionChange)="selectAllIfAllSelected()">

                            <input #filtrousuario type="text" placeholder="Buscar"
                                (input)="applyFilters($event,'ejecutivo')" class="mi-input">
                            <mat-select-trigger>
                                {{ getSelectedEjecutivosNames() || '' }}
                                <span *ngIf="group.value.ejecutivos?.length > 1"
                                    class="example-additional-selection">
                                    (+{{ group.value.ejecutivos.length - 1 }} {{ group.value.ejecutivos.length
                                    === 2
                                    ?
                                    'otro' : 'otros' }})
                                </span>
                            </mat-select-trigger>
                            <mat-option *ngFor="let topping of FilterEjecutivosGroup"
                                [value]="topping.codigo">{{
                                topping.nombre
                                }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="a-w6" appearance="outline">
                        <mat-label>POL</mat-label>
                        <mat-icon matSuffix (click)="limpiar('pol', 'group')">close</mat-icon>

                        <mat-select formControlName="pol" multiple (selectionChange)="selectAllIfAllSelected()">
                            <input #filtrousuario type="text" placeholder="Buscar"
                                (input)="applyFilters($event,'pol')" class="mi-input">
                            <mat-select-trigger>
                                {{ group.value.pol || '' }}
                                <span *ngIf="group.value.pol?.length > 1" class="example-additional-selection">
                                    (+{{ group.value.pol.length - 1 }} {{ group.value.pol.length === 2 ? 'otro'
                                    :
                                    'otros' }})
                                </span>
                            </mat-select-trigger>
                            <mat-option *ngFor="let topping of FilterPolGroup" [value]="topping.nombre">{{
                                topping.nombre
                                }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="a-w6" appearance="outline">
                        <mat-label>POD</mat-label>
                        <mat-icon matSuffix (click)="limpiar('pod', 'group')">close</mat-icon>

                        <mat-select formControlName="pod" multiple (selectionChange)="selectAllIfAllSelected()">
                            <input #filtrousuario type="text" placeholder="Buscar"
                                (input)="applyFilters($event,'pod')" class="mi-input">
                            <mat-select-trigger>
                                {{ group.value.pod || '' }}
                                <span *ngIf="group.value.pod?.length > 1" class="example-additional-selection">
                                    (+{{ group.value.pod.length - 1 }} {{ group.value.pod.length === 2 ? 'otro'
                                    :
                                    'otros' }})
                                </span>
                            </mat-select-trigger>
                            <mat-option *ngFor="let topping of FilterPodGroup" [value]="topping.nombre">{{
                                topping.nombre
                                }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="a-w1-row">
                    <mat-form-field class="a-w3" appearance="outline">
                        <mat-label>Clientes</mat-label>
                        <mat-icon matSuffix (click)="limpiar('cliente', 'group')">close</mat-icon>
                        <mat-select formControlName="cliente" multiple
                            (selectionChange)="selectAllIfAllSelected()">
                            <input #filtrousuario type="text" placeholder="Buscar"
                                (input)="applyFilters($event,'cliente')" class="mi-input">
                            <mat-select-trigger>
                                {{ group.value.cliente || '' }}
                                <span *ngIf="group.value.cliente?.length > 1"
                                    class="example-additional-selection">
                                    (+{{ group.value.cliente.length - 1 }} {{ group.value.cliente.length === 2 ?
                                    'otro'
                                    : 'otros' }})
                                </span>
                            </mat-select-trigger>
                            <mat-option *ngFor="let topping of FilterClientesGroup" [value]="topping.nombre">{{
                                topping.nombre
                                }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="a-w6" appearance="outline">
                        <mat-label>ETD</mat-label>
                        <mat-icon matSuffix (click)="limpiar('etd', 'group')">close</mat-icon>

                        <mat-select formControlName="etd" multiple (selectionChange)="selectAllIfAllSelected()">
                            <input #filtrousuario type="text" placeholder="Buscar"
                                (input)="applyFilters($event,'etd')" class="mi-input">
                            <mat-select-trigger>
                                {{ group.value.etd || '' }}
                                <span *ngIf="group.value.etd?.length > 1" class="example-additional-selection">
                                    (+{{ group.value.etd.length - 1 }} {{ group.value.etd.length === 2 ? 'otro'
                                    :
                                    'otros'
                                    }})
                                </span>
                            </mat-select-trigger>
                            <mat-option *ngFor="let topping of FilterEtdGroup" [value]="topping.nombre">{{
                                topping.nombre
                                }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="a-w6" appearance="outline">
                        <mat-label>Bkg</mat-label>
                        <mat-icon matSuffix (click)="limpiar('bkg', 'group')">close</mat-icon>

                        <mat-select formControlName="bkg" multiple (selectionChange)="selectAllIfAllSelected()">
                            <input #filtrousuario type="text" placeholder="Buscar" (input)="applyFilter($event)"
                                class="mi-input">
                            <mat-select-trigger>
                                {{ group.value.bkg || '' }}
                                <span *ngIf="group.value.bkg?.length > 1" class="example-additional-selection">
                                    (+{{ group.value.bkg.length - 1 }} {{ group.value.bkg.length === 2 ? 'otro'
                                    :
                                    'otros' }})
                                </span>
                            </mat-select-trigger>
                            <mat-option *ngFor="let topping of filteredUsers" [value]="topping.nombre">{{
                                topping.nombre
                                }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="a-w6" appearance="outline">
                        <mat-label>ServiceContract</mat-label>
                        <mat-icon matSuffix (click)="limpiar('service', 'group')">close</mat-icon>

                        <mat-select formControlName="service" multiple
                            (selectionChange)="selectAllIfAllSelected()">
                            <input #filtrousuario type="text" placeholder="Buscar"
                                (input)="applyFilters($event,'service')" class="mi-input">
                            <mat-select-trigger>
                                {{ group.value.service || '' }}
                                <span *ngIf="group.value.service?.length > 1"
                                    class="example-additional-selection">
                                    (+{{ group.value.service.length - 1 }} {{ group.value.service.length === 2 ?
                                    'otro'
                                    : 'otros' }})
                                </span>
                            </mat-select-trigger>
                            <mat-option *ngFor="let topping of FilterServicesGroup" [value]="topping.nombre">{{
                                topping.nombre
                                }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="a-w6" appearance="outline">
                        <mat-label>OV</mat-label>
                        <mat-icon matSuffix (click)="limpiar('ov', 'group')">close</mat-icon>

                        <mat-select formControlName="ov" multiple (selectionChange)="selectAllIfAllSelected()">
                            <input #filtrousuario type="text" placeholder="Buscar"
                                (input)="applyFilters($event,'ov')" class="mi-input">
                            <mat-select-trigger>
                                {{ group.value.ov || '' }}
                                <span *ngIf="group.value.ov?.length > 1" class="example-additional-selection">
                                    (+{{ group.value.ov.length - 1 }} {{ group.value.ov.length === 2 ? 'otro' :
                                    'otros'
                                    }})
                                </span>
                            </mat-select-trigger>
                            <mat-option *ngFor="let topping of FilterOvsGroup" [value]="topping.nombre">{{
                                topping.nombre
                                }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="a-w1-row">
                    <mat-form-field class="a-w3" appearance="outline">
                        <mat-label>Linea</mat-label>
                        <mat-icon matSuffix (click)="limpiar('linea', 'group')">close</mat-icon>

                        <mat-select formControlName="linea" multiple
                            (selectionChange)="selectAllIfAllSelected()">
                            <input #filtrousuario type="text" placeholder="Buscar"
                                (input)="applyFilters($event,'linea')" class="mi-input">
                            <mat-select-trigger>
                                {{ group.value.linea || '' }}
                                <span *ngIf="group.value.linea?.length > 1"
                                    class="example-additional-selection">
                                    (+{{ group.value.linea.length - 1 }} {{ group.value.linea.length === 2 ?
                                    'otro' :
                                    'otros'
                                    }})
                                </span>
                            </mat-select-trigger>
                            <mat-option *ngFor="let topping of FilterLineaGroup" [value]="topping.nombre">{{
                                topping.nombre
                                }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="a-w6" appearance="outline">
                        <mat-label>Nombre Nave</mat-label>
                        <mat-icon matSuffix (click)="limpiar('nave', 'group')">close</mat-icon>
                        <mat-select formControlName="nave" multiple
                            (selectionChange)="selectAllIfAllSelected()">
                            <input #filtrousuario type="text" placeholder="Buscar"
                                (input)="applyFilters($event,'nave')" class="mi-input">
                            <mat-select-trigger>
                                {{ group.value.nave || '' }}
                                <span *ngIf="group.value.nave?.length > 1" class="example-additional-selection">
                                    (+{{ group.value.nave.length - 1 }} {{ group.value.nave.length === 2 ?
                                    'otro' :
                                    'otros' }})
                                </span>
                            </mat-select-trigger>
                            <mat-option *ngFor="let topping of FilterNavesGroup" [value]="topping.nombre">{{
                                topping.nombre
                                }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <button mat-raised-button class="button1" (click)="GenerarReporteSeguimiento()">Buscar</button>
                    <button mat-raised-button class="button1" (click)="LimpiarFiltros()">Limpiar</button>
                    <button mat-raised-button class="button1" (click)="exportReportTrack()">Exportar</button>
                </div>
            </form>
        </mat-expansion-panel>
    </mat-accordion>
</div>
<br>
<div class="contenido-tabla">
    <table>
        <tr class="cabecera">
            <td class="items-cabecera">
                <div class="cabecera-filtros">DateX<mat-icon (click)="sortColumn('fecha')"
                        class="icons-filtro">{{orderFieldName == 'fecha' ? statusFieldName :
                        'sort'}}</mat-icon></div>
            </td>
            <td class="items-cabecera ov">
                <div class="cabecera-filtros">OV<mat-icon (click)="sortColumn('ov')"
                        class="icons-filtro">{{orderFieldName == 'ov' ? statusFieldName : 'sort'}}</mat-icon>
                </div>
            </td>
            <td class="items-cabecera">
                <div class="cabecera-filtros">Ejecutivo<mat-icon (click)="sortColumn('ejecutivo')"
                        class="icons-filtro">{{orderFieldName == 'ejecutivo' ? statusFieldName :
                        'sort'}}</mat-icon></div>

            </td>
            <td class="items-cabecera">
                <div class="cabecera-filtros">Cliente<mat-icon (click)="sortColumn('clienteCortado')"
                        class="icons-filtro">{{orderFieldName == 'clienteCortado' ? statusFieldName :
                        'sort'}}</mat-icon></div>
            </td>
            <td class="items-cabecera">
                <div class="cabecera-filtros">Linea<mat-icon (click)="sortColumn('linea')"
                        class="icons-filtro">{{orderFieldName == 'linea' ? statusFieldName :
                        'sort'}}</mat-icon></div>
            <td class="items-cabecera">
                <div class="cabecera-filtros">ServiceContract<mat-icon (click)="sortColumn('servcontract')"
                        class="icons-filtro">{{orderFieldName == 'servcontract' ? statusFieldName :
                        'sort'}}</mat-icon></div>
            </td>
            <td class="items-cabecera">
                <div class="cabecera-filtros">NombreNave<mat-icon (click)="sortColumn('nave')"
                        class="icons-filtro">{{orderFieldName == 'nave' ? statusFieldName :
                        'sort'}}</mat-icon></div>
            </td>
            <td class="items-cabecera">
                <div class="cabecera-filtros">ETD<mat-icon (click)="sortColumn('etd')"
                        class="icons-filtro">{{orderFieldName == 'etd' ? statusFieldName :
                        'sort'}}</mat-icon></div>
            </td>
            <td class="items-cabecera letras">
                <div class="cabecera-filtros">Bkg<mat-icon (click)="sortColumn('bkg')"
                        class="icons-filtro">{{orderFieldName == 'bkg' ? statusFieldName :
                        'sort'}}</mat-icon></div>
            </td>
            <td class="items-cabecera">
                <div class="cabecera-filtros">POL<mat-icon (click)="sortColumn('pol')"
                        class="icons-filtro">{{orderFieldName == 'pol' ? statusFieldName :
                        'sort'}}</mat-icon></div>
            </td>
            <td class="items-cabecera">
                <div class="cabecera-filtros">POD<mat-icon (click)="sortColumn('pod')"
                        class="icons-filtro">{{orderFieldName == 'pod' ? statusFieldName :
                        'sort'}}</mat-icon></div>
            </td>
            <td class="items-cabecera numeros">
                <div class="cabecera-filtros">20ST<mat-icon (click)="sortColumn('st20')"
                        class="icons-filtro">{{orderFieldName == 'st20' ? statusFieldName :
                        'sort'}}</mat-icon></div>
            </td>
            <td class="items-cabecera numeros">
                <div class="cabecera-filtros">40ST<mat-icon (click)="sortColumn('st40')"
                        class="icons-filtro">{{orderFieldName == 'st40' ? statusFieldName :
                        'sort'}}</mat-icon></div>
            </td>
            <td class="items-cabecera numeros">
                <div class="cabecera-filtros">40HC<mat-icon (click)="sortColumn('hc40')"
                        class="icons-filtro">{{orderFieldName == 'hc40' ? statusFieldName :
                        'sort'}}</mat-icon></div>
            </td>
            <td class="items-cabecera numeros">
                <div class="cabecera-filtros">40NR<mat-icon (click)="sortColumn('nr40')"
                        class="icons-filtro">{{orderFieldName == 'nr40' ? statusFieldName :
                        'sort'}}</mat-icon></div>
            </td>
            <td class="items-cabecera numeros">
                <div class="cabecera-filtros">TEU<mat-icon (click)="sortColumn('teu')"
                        class="icons-filtro">{{orderFieldName == 'teu' ? statusFieldName :
                        'sort'}}</mat-icon></div>
            </td>
        </tr>
        <tr *ngFor="let item of dataReporteSeguimiento ; let i = index" class="contenido"
            [ngClass]="{'sombra': (i % 2) == 0}">
            <td class="items-contenido">{{item.fecha}}</td>
            <td class="items-contenido"
                [ngClass]="{'azul': item.estado == 'E','verde': item.estado == 'T' || item.estado == 'I'}">
                {{item.ov}}</td>
            <td class="items-contenido">{{item.ejecutivo}}</td>
            <td class="items-contenido">{{item.clienteCortado}}</td>
            <td class="items-contenido"
                [ngClass]="{'hpl': item.linea == 'HPL','msc': item.linea == 'MSC','msk':item.linea == 'MAERSK'}">
                {{item.linea}}</td>
            <td class="items-contenido">{{item.servcontract}}</td>
            <td class="items-contenido">{{item.nave}}</td>
            <td class="items-contenido">{{item.etd}}</td>
            <td class="items-contenido letras">{{item.bkg}}</td>
            <td class="items-contenido">{{item.pol}}</td>
            <td class="items-contenido">{{item.pod}}</td>
            <td class="items-contenido">{{item.st20}}</td>
            <td class="items-contenido">{{item.st40}}</td>
            <td class="items-contenido">{{item.hc40}}</td>
            <td class="items-contenido">{{item.nr40}}</td>
            <td class="items-contenido">{{item.teu}}</td>
        </tr>
        <tr class="totales">
            <td class="items-totales" colspan="11">Total</td>
            <td class="items-totales">{{getTotalCost('st20',dataReporteSeguimiento)}}</td>
            <td class="items-totales">{{getTotalCost('st40',dataReporteSeguimiento)}}</td>
            <td class="items-totales">{{getTotalCost('hc40',dataReporteSeguimiento)}}</td>
            <td class="items-totales">{{getTotalCost('nr40',dataReporteSeguimiento)}}</td>
            <td class="items-totales">{{getTotalCost('teu',dataReporteSeguimiento)}}</td>
        </tr>
    </table>
</div>
<div class="a-footer"></div>